
    var riot = require('riot')
    
riot.tag2('qualification_details', '<raw content="{opts.opts.qualification_details}"></raw> <ul class="nav nav-tabs"> <li each="{ref, i in opts.psedata.qualifications}" class="{active:parent.qualification_id == i}"><a href="./qualification_details/{i+1}" class="heading btn">{i+1}</a></li> <li><a onclick="{addQualification}" class="btn btn-success">Add Qualification</a></li> <li> <confirm onconfirm="{deleteQualification}"><a class="btn btn-danger">Delete Qualification</a></confirm> </li> </ul> <div class="tab-content"> <div class="tab-pane {active: qualification}"> <div class="col-xs-10 col-xs-offset-1"> <form class="form-horizontal"> <popover parent="{infoParent}"> <raw content="{parent.info}"></raw> </popover> <forminput label="Profesional Body" name="prof_body" value="{qualification.prof_body}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.qualification.prof_body)}"></forminput> <forminput label="Grade of Membership" name="prof_grade" value="{qualification.prof_grade}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.qualification.prof_grade)}"></forminput> <forminput label="Membership Number" name="prof_mem_number" value="{qualification.prof_mem_number}" onupdate="{handleUpdate}"></forminput> <forminput label="Professional Qualifications" name="prof_qualification" value="{qualification.prof_qualification}" onupdate="{handleUpdate}"></forminput> <forminput label="Admission Date*" name="prof_date" value="{qualification.prof_date}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.qualification.prof_date)}" isrequired></forminput> <forminput label="Method of Entry-Normal,Special Examination,Exemption" name="prof_entry" value="{qualification.prof_entry}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.qualification.prof_entry)}"></forminput> <forminput label="Subjects taken in Examination" name="prof_subjects" value="{qualification.prof_subjects}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.qualification.prof_subjects)}"></forminput> <formselect label="Method of Verification" name="qual_verification" value="{qualification.qual_verification}" default="Please Select" options="{opts.selects.qualification_verifications}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.qualification.qual_verification)}" isrequired></formselect> <formselect label="Referee Attestation" name="prof_referee" value="{qualification.prof_referee}" default="Please Select" options="{referees}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.qualification.prof_referee)}" if="{qualification.qual_verification == \'Referee Attestation\'}"></formselect> <fileinput label="Upload File" files="{qualificationFiles}" name="qual_files" onupdate="{handleUpload}" onremove="{handleRemove}" isrequired="{qualificationErrors.indexOf(\'qual_files\') &gt; -1}" if="{qualification.qual_verification != \'Referee Attestation\'}"></fileinput> </form> </div> </div> </div>', '', '', function(opts) {
this.infobutton = "<span class=\"fa fa-info\" style=\"pointer-events:none\"></span>";

this.mounted = false;

this.on('mount', function() {
  this.mounted = true;
  if (opts.errors != null) {
    return setTimeout((function(_this) {
      return function() {
        return _this.checkErrors();
      };
    })(this));
  }
});

this.showInfo = (function(_this) {
  return function(info, e) {
    _this.info = info;
    _this.infoParent = e.target;
    _this.tags.popover.clicked(e);
    return _this.update();
  };
})(this);

this.files = [];

this.referees = [];

this.qualifications = [];

this.on('update', function() {
  if (opts.files != null) {
    this.files = opts.files.filter(function(f) {
      return f.path.match(/^pq_/);
    });
  }
  if ((opts.errors != null) && this.mounted) {
    this.checkErrors();
  }
  if (opts.psedata != null) {
    this.referees = opts.psedata.referees.filter(function(r) {
      var ref;
      return ((ref = r.ref_name) != null ? ref.length : void 0) > 0;
    }).map(function(r) {
      return {
        label: r.ref_name,
        value: r.ref_name
      };
    });
    return this.load();
  }
});

this.checkErrors = (function(_this) {
  return function() {
    _this.qualificationErrors = opts.errors.filter(function(e) {
      return e.tab === 'qualifications';
    }).map(function(e) {
      return e.field;
    });
    _this.update();
    return _this.qualificationErrors.forEach(function(field) {
      return _this.tags[field].tags['formgroup'].trigger('validate');
    });
  };
})(this);

this.load = function() {
  var ref, regex;
  this.qualifications = opts.psedata.qualifications;
  this.qualification_id = opts.params.qualification_id != null ? opts.params.qualification_id - 1 : 0;
  if (((ref = this.qualifications) != null ? ref[this.qualification_id] : void 0) != null) {
    this.qualification = this.qualifications[this.qualification_id];
  }
  regex = new RegExp('pq_' + (this.qualification_id + 1) + '_');
  this.qualificationFiles = this.files.filter(function(f) {
    return f.path.match(regex);
  });
  return this.update();
};

this.addQualification = function() {
  this.qualifications.push({});
  opts.page.redirect('qualification_details/' + this.qualifications.length);
  return this.update();
};

this.deleteQualification = (function(_this) {
  return function() {
    _this.qualifications.splice(_this.qualification_id, 1);
    opts.page.redirect('qualification_details/' + _this.qualifications.length);
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(val) {
    _this.qualification[val.name] = val.value;
    return opts.onupdate('qualifications', _this.qualification_id, _this.qualification);
  };
})(this);

this.handleUpload = (function(_this) {
  return function(val) {
    var data, file;
    if ((val != null ? val[0] : void 0) != null) {
      file = val[0];
      data = new FormData();
      data.append('file', file);
      data.append('name', 'pq_' + (_this.qualification_id + 1) + "_" + file.name);
      return fetch('/duocms/api/pse/file', {
        method: 'POST',
        credentials: "include",
        headers: {
          'x-csrf-token': window.csrf
        },
        body: data
      }).then(function() {
        return opts.onupdate('files', 'add', {
          path: 'pq_' + (_this.qualification_id + 1) + "_" + file.name
        });
      });
    }
  };
})(this);

this.handleRemove = (function(_this) {
  return function(file) {
    return fetch('/duocms/api/pse/file?path=' + file.path, {
      method: 'DELETE',
      credentials: "include",
      headers: {
        'x-csrf-token': window.csrf
      }
    }).then(function() {
      return opts.onupdate('files', 'remove', file);
    });
  };
})(this);
});
    
  